import ChoiceListSection from './ChoiceListSection.jsx';

const SingleSelectSection = ({ section }) => (
  <ChoiceListSection section={section} control="radio" multiple={false} maxVisible={7} />
);

export default SingleSelectSection;
